/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

/* -------------------------------------------------------------------------- */
/*                                    Types.                                  */
/* -------------------------------------------------------------------------- */
export type TAddProductionMethod =
	| 'import'
	| 'manual'
	| null;

type TCsvColumnOption = {
	label: string;
	value: string;
	required: boolean;
};

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IAddProductionSlice {
	// State existant
	isAddProduction: boolean;
	productionMethod: TAddProductionMethod;
	isOpenModalCancelAddProduction: boolean;
	isAddProductionFromFile: boolean;

	// Nouveaux états CSV
	fileData: any;
	columns: TCsvColumnOption[];
	delimiterCSV: string;
	columnsCSV: any[];
	selectedColumnsCSV: any[];
	addedProductions: any[];

	// Actions
	setIsAddProduction: (_isAddProduction: boolean) => void;
	setIsAddProductionFromFile: (
		_isAddProduction: boolean
	) => void;
	setProductionMethod: (
		method: TAddProductionMethod
	) => void;

	// Nouvelles actions CSV
	setFileData: (data: any) => void;
	setColumns: (columns: TCsvColumnOption[]) => void;
	setDelimiterCSV: (delimiter: string) => void;
	setColumnsCSV: (columns: any[]) => void;
	setSelectedColumnsCSV: (columns: any[]) => void;
	setAddedProductions: (addedProductions: any[]) => void;
	resetImportData: () => void; // Utile pour vider après l'import
	setIsOpenModalCancelAddProduction: (
		open: boolean
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */
const initialState = {
	isAddProduction: false,
	isAddProductionFromFile: false,
	isOpenModalCancelAddProduction: false,
	productionMethod: null,
	fileData: undefined,
	columns: [],
	delimiterCSV: '',
	columnsCSV: [],
	selectedColumnsCSV: [],
	addedProductions: [],
};

export const createAddProductionSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IAddProductionSlice
> = (set) => ({
	...initialState,

	// Actions existantes
	setIsAddProduction: (isAdd) =>
		set({ isAddProduction: isAdd }),
	setIsAddProductionFromFile: (isAdd) =>
		set({ isAddProductionFromFile: isAdd }),
	setProductionMethod: (method) =>
		set({ productionMethod: method }),

	// Nouvelles actions
	setFileData: (fileData) => set({ fileData }),
	setColumns: (columns) => set({ columns }),
	setDelimiterCSV: (delimiterCSV) =>
		set({ delimiterCSV }),
	setColumnsCSV: (columnsCSV) => set({ columnsCSV }),
	setSelectedColumnsCSV: (selectedColumnsCSV) =>
		set({ selectedColumnsCSV }),

	// Reset complet de la partie import
	resetImportData: () =>
		set({
			fileData: undefined,
			columns: [],
			delimiterCSV: '',
			columnsCSV: [],
			selectedColumnsCSV: [],
		}),
	setIsOpenModalCancelAddProduction: (open) =>
		set({ isOpenModalCancelAddProduction: open }),
	setAddedProductions: (addedProductions) =>
		set({ addedProductions }),
});
